import { render, staticRenderFns } from "./addEventV2.vue?vue&type=template&id=1074c576&scoped=true"
import script from "./addEventV2.vue?vue&type=script&lang=js"
export * from "./addEventV2.vue?vue&type=script&lang=js"
import style0 from "./addEventV2.vue?vue&type=style&index=0&id=1074c576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1074c576",
  null
  
)

export default component.exports